<template lang='pug'>
  v-card( class='elevation-0' )
    r-table(
      loading-text='Cargando cuentas corrientes...'
      no-data-text='Sin cuentas corriente.'
      no-search
      no-remove
      ref='table'
      v-if='hasCustomer'
      v-bind='tableReceivableProps'
      @detail='submitDetail'
    )
      template( slot='prepend' )
        v-text-field(
          label='Folio'
          outline
          single-line
          v-model='folio'
        )
          template( slot='prepend-inner' )
            span.body-2( style='margin-top: 6px;' ) Folio
      template( slot='actions' slot-scope='props' )
        v-btn-action(
            color='success'
            tooltip='Detalle Pago'
            @click='submitShowPayment(props.item)'
            v-if="props.item.status==='Pagado'"
          )
            v-icon monetization_on

    //
    r-dialog( 
      content-class='grey lighten-3'
      no-confirm
      title='Nota de debito'
      v-model='dialogs.debit' 
    )
      r-form(
        class='white'
        no-submit
        reset-text='cerrar'
        v-bind='formDebitNoteProps'
        v-model='selected'
        @reset='toggleDialog("debit")'
      )

    r-dialog( 
      content-class='grey lighten-3'
      no-confirm
      title='Factura de venta'
      v-model='dialogs.invoice' 
    )
      r-form(
        class='white'
        no-submit
        reset-text='cerrar'
        v-bind='formInvoiceProps'
        v-model='selected'
        @reset='toggleDialog("invoice")'
      )

    //
    r-dialog( 
      content-class='grey lighten-3'
      no-confirm
      title='Detalle pago(s)'
      width='1080'
      v-model='dialogs.payments' 
    )
      r-table(
        loading-text='Cargando pago...'
        no-data-text='Sin pago.'
        no-actions
        no-pagination
        no-search
        no-filter
        show-native-pagination
        ref='table'
        v-bind='tablePaymentsProps'
      )
</template>

<script>
  //
  import { RDialog, RForm, RTable, VBtnAction } from '@/components/reusable_components/next'
  //
  import SlCustomer from '@/models/Sale/SlCustomer'
  //
  import PosCustomerReceivablePaymentModel from '@/models/POS/PosCustomerReceivablePayment'
  import TransformedPaymentHeaders from '@/views/POS/PosCustomerReceivablePayment/TransformedPaymentHeaders'
  //
  import SlCustomerAccountReceivableModel from '@/models/Sale/SlCustomerAccountReceivable'
  import SlCustomerAccountReceivableFilters from '@/views/Sale/SlCustomerAccountReceivable/SlCustomerAccountReceivableFilters'
  import SlCustomerAccountReceivableHeaders from '@/views/Sale/SlCustomerAccountReceivable/SlCustomerAccountReceivableHeaders'
  //
  import SaleInvoiceFields from '@/views/Sale/SlSaleInvoice/SlSaleInvoiceFields'
  import SaleDebitNoteFields from '@/views/Sale/SlSaleDebitNote/SlSaleDebitNoteFields'
  //
  export default {
    components: {
      RDialog,
      RForm,
      RTable,
      VBtnAction,
    },
    computed: {

      /**
       * { function_description }
       *
       * @return     {Object}  { description_of_the_return_value }
       */
      formDebitNoteProps() {
        return {
          fields: SaleDebitNoteFields.variant('update').readonly(),
        }
      },

      /**
       * { function_description }
       *
       * @return     {Object}  { description_of_the_return_value }
       */
      formInvoiceProps() {
        return {
          fields: SaleInvoiceFields.readonly(),
        }
      },

      /**
       * Determines if customer.
       *
       * @return     {boolean}  True if customer, False otherwise.
       */
      hasCustomer() {
        return !!this.customer
      },

      /**
       * { function_description }
       *
       * @return     {Object}  { description_of_the_return_value }
       */
      tableReceivableFilter() {
        return {
          number: this.folio,
          sl_customer_account_id: this.customer ? this.customer.sl_customer_account_id : null,
        }
      },

      /**
       * { function_description }
       *
       * @return     {Object}  { description_of_the_return_value }
       */
      tableReceivableProps() {
        return {
          filters: SlCustomerAccountReceivableFilters,
          headers: SlCustomerAccountReceivableHeaders,
          service: SlCustomerAccountReceivableModel,
          paramFilter: this.tableReceivableFilter,
        }
      },

      /**
       * { function_description }
       *
       * @return     {Object}  { description_of_the_return_value }
       */
      tablePaymentsProps() {
        return {
          headers: TransformedPaymentHeaders,
          service: PosCustomerReceivablePaymentModel,
          paramFilter: {
            sl_customer_receivable_id: this.account_receivable_id,
          },
          parser: this.parserPayments,
        }
      },
    },
    data() {
      return {
        folio: '',
        account_receivable_id: 0,
        customer: null,
        dialogs: {
          debit: false,
          invoice: false,
          payments: false,
        },
        selected: {},
      }
    },
    methods: {

      /**
       * Gets the customer.
       *
       * @return     {<type>}  The customer.
       */
      getCustomer() {
        return SlCustomer
          .find(this.$route.params.id)
          .then(this.setCustomer)
      },

      parserPayments(res) {

        //
        res.data = res.data.reduce((payments, receive) => [ ...payments, ...receive.transformed_payments ], [])

        //
        return res
      },

      /**
       * Sets the customer.
       *
       * @param      {<type>}  customer  The customer
       */
      setCustomer(customer) {
        this.customer = customer
      },

      /**
       * { function_description }
       *
       * @param      {<type>}  event   The event
       */
      submitShowPayment: function(event) {
          this.account_receivable_id = event.id
          this.dialogs.payments = true
      },

      /**
       * Fetches the given item.
       *
       * @param      {<type>}  item    The item
       * @return     {<type>}  { description_of_the_return_value }
       */
      fetch(item) {
        return item.is_invoice ? item.fetch('sl_sale_invoice') : item.fetch('sl_sale_debit_note')
      },

      /**
       * Resets the object.
       */
      reset() {
        this.getCustomer()
      },

      /**
       * Sets the selected.
       *
       * @param      {<type>}  item    The item
       */
      setSelected(item) {
        this.selected = item.reset()
      },

      /**
       * @description
       * { function_description }
       *
       * @param      {<type>}  event   The event
       */
      submitDetail(event) {
        this.toggleDialog(event.item.is_invoice ? 'invoice' : 'debit')
        this.fetch(event.item).then(this.setSelected)
      },

      /**
       * @description
       * { function_description }
       *
       * @param      {<type>}  dialogName  The dialog name
       */
      toggleDialog(dialogName) {
        this.dialogs[dialogName] ^= 1
      },
    },
    beforeMount() {
      this.reset()
    },
  }
</script>
